// Shared shapes for the gamification surfaces.
//
// This file replaces the old previewData.ts. That file held hardcoded demo
// values ("Supplier Compliance", a fake streak, a fake rank, fake programs
// due) that every component fell back to whenever real data was missing, and
// those values shipped to real learners once the member Learning Framework
// dashboard went GA (RDP, Sep 2026: a learner with no programs at all was
// shown "Continue: Supplier Compliance · 50% complete · #3").
//
// Rule from that incident: real data or nothing. Nothing in this file holds a
// value a user can read — only types and the one real route constant.
// Scope + rationale: docs/EPIC-gamification.md.

/** Where the Elliott orb and chat entry points navigate to. */
export const ELLIOTT_CHAT_ROUTE = '/app/charlie';

// Leaderboard, professionalized: top 3 + your own position, never the full
// ranking (bottom performers are never displayed — JWL 2025 review). Two
// boards, This Week / All Time, both ranked by lessons completed. Filled
// exclusively by GET /gamification/learner/summary.
export interface TopPerformerRow {
  rank: number;
  name: string;
  lessons: number;
}

export interface TopPerformersBoard {
  top: TopPerformerRow[];
  you: { rank: number; lessons: number };
  lessonsToTop3: number;
}

export interface TopPerformersData {
  thisWeek: TopPerformersBoard;
  allTime: TopPerformersBoard;
}

// Programs Due — the red exclamation chip and its flyout. `due` is the
// display string ('30 Aug 2026') formatted from `dueBy` (unix seconds), which
// is what urgency is worked out from.
export interface ProgramDueItem {
  programName: string;
  due: string;
  dueBy: number | null;
  isOverdue?: boolean;
}
